// export default StockInReportAdmin
import React, { useState, useEffect } from 'react';
// import "./CheckWarranty.scss";
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../services/api/API';
import CustomTable from '../../../../customComponents/CustomTable';
// import ROUTES_NAVIGATION from "../../../../routes/routes";
import viewIcon from '../../../../../Assets/icons/ClaimIcon.svg';
import ListLogisticsFilters from '../../../Logistics/LogisticsFilter';
import DownloadSVG from '../../../../../Assets/icons/DownloadIconMIS.svg';
import CustomMisTable from '../../../../customComponents/customMisReportTable';
import { showErrorAlert } from '../../../../customComponents/CustomSweetAlert/errorsweetalert';
import { FiDownload } from 'react-icons/fi';
// import DetailsTable from "../../Admin/OrderManagement/CustomOrderTable/CustomOrderTable";

const StockInReportAdmin = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [variantOptions, setVariantOptions] = useState([]);
  const [colorOptions, setColorOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [filterList, setFilterList] = useState();
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterFormData, setFilterFormData] = useState({});
  const [filters, setFilters] = useState({});
  const [vinNoData, setVinNoData] = useState([]);
  // const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [itemsPerPage] = useState(10);

  const [accessoryOptions, setaccessoryOptions] = useState([]);

  const [dealerOption, setDealerOptions] = useState([]);

  const navigate = useNavigate();
  const token = localStorage.getItem('authToken');
  const dealerId = localStorage.getItem('dealerId');
  localStorage.removeItem('JobCardComplainData');

  useEffect(() => {
    fetchItemOptions();
  }, []);

  const fetchItemOptions = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axiosInstance.post(
        '/item/ddlitem',
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setaccessoryOptions(options);
    } catch (error) {
      console.error('Error fetching variant options:', error);
    }
  };

  useEffect(() => {
    // fetchJobCardList();
  }, [filterList]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchStockReport(newPage);
  };

  // const fetchJobCardList = async () => {
  //     const allfilteredData = filters;
  //     const payload = {
  //         // business_partner_id: 1,
  //         // dealerId: dealerId || "",
  //         // dealerId: allfilteredData?.dealerId ? allfilteredData?.dealerId : null,
  //         // fromDate:"",
  //         // toDate:"",
  //         state_id: "",
  //         services_by: "",
  //         servicesValue_Id: "",
  //         orderBy: "po_id desc",
  //         page: 0,
  //         pageSize: 10,

  //         fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : null,
  //         toDate: allfilteredData?.toDate ? allfilteredData?.toDate : null,
  //     }
  //     try {
  //         // setTableLoader(true)
  //         const response = await axiosInstance.post(
  //             "/admin/mis-report", payload,
  //             {
  //                 headers: {
  //                     "Content-Type": "application/json",
  //                     Authorization: `Bearer ${token}`,
  //                 },
  //             }
  //         );
  //         // setTableLoader(false)
  //         const formattedData = response?.data?.data?.data.map((item, index) => ({
  //             ...item,
  //             item_name: item.item_name || "--",
  //             model_name: item.model_name || "--",
  //             variant_name: item.variant_name || "--"
  //         }))
  //         const totalRecordsData = response?.data?.data?.totalRecords
  //         setTotalRecords(totalRecordsData);

  //         setVinNoData(formattedData)

  //     } catch (error) {
  //         console.error("Error fetching business partners:", error);
  //         // setIsSearchPerformed(false);
  //     }
  // };
  const onClickNavigetion = (item) => {
    return (
      <div onClick={() => handleEdit(item)}>
        <span style={{ color: 'green' }}> {item?.job_card_no}</span>
      </div>
    );
  };

  const handleEdit = (rowData) => {
    navigate('add-job-card', {
      state: { jobCardDataDetails: JSON.parse(JSON.stringify(rowData)) },
    });
  };

  const handleViewButton = (rowData) => {
    navigate('job-card-details', {
      state: { data: JSON.parse(JSON.stringify(rowData)) },
    });
  };

  // Table headers
  const Job_Card_TABLE_HEADERS = [
    // "Dealer Name",
    'Item Type',
    'Model',
    // "Variant",
    'Variant/Item Name',
    'Color',
    // "Item Name",
    'Inward Quantity',
    'Outward Quantity',
    'Available stock',
    "Created Date",
  ];

  // Key mapping for CustomTable component
  const BUSINESS_PARTNER_KEY_MAPPING = {
    'Dealer Name': 'dealer_name',
    'Item Type': 'record_type',
    'Variant/Item Name': 'name',
    Model: 'model_name',
    'Item Name': 'item_name',
    Variant: 'variant_name',
    Color: 'color_name',
    'Inward Quantity': 'total_quantity',
    'Outward Quantity': 'quantity_sell',
    'Available stock': 'available_quantity',
    "Created Date": "created_date",
  };

  const onclickFilter = (row) => {
    setFilterList(row);
  };

  useEffect(() => {
    // fetchJobCardList();
  }, [filters]);

  // const clearFilter = () => {
  //   setFilterFormData({});
  //   setFilters({});
  //   fetchJobCardList();
  // };
  useEffect(() => {
    if (searchTerm === '') {
      // fetchJobCardList();
    }
  }, [searchTerm]);

  // const handleSearch = () => {
  //   setFilters({
  //     vinNumber: filterFormData.searchTerm || null
  //   });
  //   // setIsSearchPerformed(true);
  //   fetchJobCardList();
  // };
  const clearSearchAndFetch = () => {
    setSearchTerm('');
  };

  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleClear = () => {
    setFilterFormData({});
  };
  const handleClaim = () => {
    console.log('clicked');
    // navigate(ROUTES_NAVIGATION.ADDJOBCARD)
  };

  useEffect(() => {
    fetchDealers();
  }, []);

  const fetchDealers = async () => {
    try {
      const response = await axiosInstance.post('/dealer/ddldealer', {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response?.data?.data?.data;

      const dealerOptions = data.map((dealer) => ({
        value: dealer.dealer_id,
        label: dealer.dealer_name,
      }));

      setDealerOptions(dealerOptions);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchModelOptions();
  }, []);

  const fetchModelOptions = async () => {
    try {
      const payload = {
        orderBy: 'model_id desc',
        page: 0,
        pageSize: 100,
      };

      const response = await axiosInstance.post('/model/ddlmodel', payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      const options = response.data.data.data.map((model) => ({
        label: model.NAME,
        value: model.ID,
      }));
      console.log(options, 'responseVal');

      setModelOptions(options);
    } catch (error) {
      console.error('Error fetching model options:', error);
    }
  };

  useEffect(() => {
    // const colorId = formData.color
    const modelId = filterFormData.modelId;
    const dealerIdVal = filterFormData.dealerId;
    const colorIdVal = filterFormData.colorId;

    if (modelId && colorIdVal) {
      fetchVariantOptions(modelId, dealerIdVal, colorIdVal);
    }
  }, [filterFormData.modelId, filterFormData.dealerId, filterFormData.colorId]);

  const fetchVariantOptions = async (modelId, dealerIdVal, colorIdVal) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axiosInstance.post(
        '/variant/ddlvariant',
        {
          color_id: colorIdVal,
          model_id: modelId,
          dealer_id: dealerIdVal,
          batteryType: 'N',
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setVariantOptions(options);
    } catch (error) {
      console.error('Error fetching variant options:', error);
    }
  };

  useEffect(() => {
    const modelId = filterFormData.modelId;
    if (modelId) {
      fetchColorOptions(modelId);
    }
  }, [filterFormData.modelId]);

  const fetchColorOptions = async (modelId) => {
    try {
      const payload = {
        page: 0,
        pageSize: 100,
        model_id: modelId,
      };

      const response = await axiosInstance.post('/color/ddlcolor', payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      const options = response.data.data.data.map((color) => ({
        label: color.NAME,
        value: color.ID,
      }));

      setColorOptions(options);
    } catch (error) {
      console.error('Error fetching model options:', error);
    }
  };

  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    // Format to YYYY-MM-DD without timezone influence
    return new Date(d.getTime() - d.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10);
  };

  const fetchStockReport = async (page = 0, pageSize = 10) => {
    const allfilteredData = filters;

    const payload = {
      dealerId: allfilteredData?.dealerId ? allfilteredData?.dealerId : null,
      stateId: allfilteredData?.stateId ? allfilteredData?.stateId : null,
      // fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : null,
      // toDate: allfilteredData?.fromDate ? allfilteredData?.toDate : null,
      fromDate: formatDate(allfilteredData?.fromDate),
      toDate: formatDate(allfilteredData?.toDate),
      modelId: allfilteredData?.modelId ? allfilteredData?.modelId : null,
      variantId: allfilteredData?.variantId ? allfilteredData?.variantId : null,
      itemId: allfilteredData?.itemId ? allfilteredData?.itemId : null,
      colorId: allfilteredData?.colorId || null,
      orderBy: 'dealer_name desc',
      page,
      // colorId: null,
      pageSize,
      itemType: allfilteredData?.itemType ? allfilteredData?.itemType : '',
    };

    try {
      const response = await axiosInstance.post(
        '/instock/stock-report-list',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      // const salesData = response?.data?.data || [];
      const formattedData = response.data.data.data.map((item) => ({
        dealer_name: item.dealer_name || '--',
        model_name: item.model_name || '--',
        color_name: item.color_name || '--',
        variant_name: item.variant_name || '--',
        available_quantity: item.available_quantity || '--',
        total_quantity: item.total_quantity || '--',
        quantity_sell: item.quantity_sell || '--',
        item_name: item.item_name || '--',
        created_date: item.created_date || '--',

        name: item.name || '--',
        record_type: item.record_type || '--',
      }));
      const totalRecordsData = response?.data?.data?.totalRecords;
      setTotalRecords(totalRecordsData); // or use a separate `totalRecords` field if available
      setVinNoData(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));

      // const fullData = response?.data?.data?.data || [];
      // setVinNoData(fullData);
      // setTotalPages(Math.ceil(fullData.length / itemsPerPage));
      // setCurrentPage(0); // reset to first page
      // console.log("Formatted stock Report Data:", fullData);
    } catch (error) {
      console.error('Failed to fetch stock report:', error);
    }
  };

  useEffect(() => {
    fetchStockReport();
  }, []);

  // const paginatedData = vinNoData.slice(
  //     currentPage * itemsPerPage,
  //     currentPage * itemsPerPage + itemsPerPage
  //   );

  const PhysicalStockTakingInputs = [
    {
      name: 'itemType',
      label: 'Item Type',
      placeholder: 'Enter',
      type: 'dropdown',
      options: [
        { value: 'V', label: 'Vehicle' },
        // { value: "A", label: "Accessories" },
        { value: 'S', label: 'Spare Part' },
      ],
      required: true,
      gridClass: 'col-lg-3',
      validation: { required: true },
    },
    ...(filterFormData.itemType !== 'V'
      ? [
          {
            name: 'itemId',
            label: 'Item Name',
            placeholder: '',
            type: 'dropdown',
            options: accessoryOptions,
            required: true,
            gridClass: 'col-lg-3',
            validation: { required: true },
          },
        ]
      : []),
    {
      // name: "variant",
      name: 'modelId',
      label: 'Model',
      placeholder: 'Select Model',
      type: 'dropdown',
      options: modelOptions,
      // required: true,
      gridClass: 'col-lg-3',
      // validation: { required: true }
    },
    {
      name: 'colorId',
      label: 'Color',
      placeholder: 'Color',
      type: 'dropdown',
      options: colorOptions,
      // disabled:true,
      gridClass: 'col-lg-3',
    },
    ...(filterFormData.itemType === 'V'
      ? [
          {
            // name: "variant",
            name: 'variantId',
            label: 'Variant',
            placeholder: '',
            type: 'dropdown',
            options: variantOptions,
            // required: true,
            gridClass: 'col-lg-3',
            // validation: { required: true },
          },
        ]
      : []),
    // {
    //   // name: "variant",
    //   name: "variantId",
    //   label: "Variant",
    //   placeholder: "Select Variant",
    //   type: "dropdown",
    //   options: variantOptions,
    //   // required: true,
    //   gridClass: "col-lg-3",
    //   // validation: { required: true },
    // },
    {
      name: 'fromDate',
      label: 'From Date',
      type: 'date',
      maxDate: new Date(),
      // required: true,
      gridClass: 'col-lg-3',
    },
    {
      name: 'toDate',
      label: 'To Date',
      type: 'date',
      maxDate: new Date(),
      // required: true,
      gridClass: 'col-lg-3',
    },
  ];

  const handleSearch = () => {
    // Update the filters state with the current form data
    setFilters({
      itemType: filterFormData?.itemType ? filterFormData?.itemType : null,
      fromDate: filterFormData.fromDate || null,
      toDate: filterFormData.toDate || null,
      modelId: filterFormData?.modelId ? filterFormData?.modelId : null,
      variantId: filterFormData?.variantId ? filterFormData?.variantId : null,
      itemId: filterFormData?.itemId ? filterFormData?.itemId : null,
      dealerId: filterFormData?.dealerId ? filterFormData?.dealerId : null,
      colorId: filterFormData?.colorId || null,
    });
  };
  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    // fetchJobCardList();
  };

  const downloadExcel = async () => {
    const allfilteredData = filters;
    const payload = {
      //   dealerId: allfilteredData?.dealerId ? allfilteredData?.dealerId : null,
      //   stateId: allfilteredData?.stateId ? allfilteredData?.stateId : null,
      itemType: allfilteredData?.itemType ? allfilteredData?.itemType : null,
      fromDate: formatDate(allfilteredData?.fromDate),
      toDate: formatDate(allfilteredData?.toDate),
      modelId: allfilteredData?.modelId ? allfilteredData?.modelId : null,
      variantId: allfilteredData?.variantId ? allfilteredData?.variantId : null,
      itemId: allfilteredData?.itemId ? allfilteredData?.itemId : null,
      colorId: allfilteredData?.colorId || null,
      //   orderBy: "po_id desc",
      //   page: 0,
      //   colorId: allfilteredData?.colorId || null,
      //   pageSize: 10,
    };

    try {
      const response = await axiosInstance.post(
        '/instock/stock-report-list-excell',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          responseType: 'blob', // Important: Ensures the response is treated as a file
        },
      );

      // Create a Blob from the response
      const blob = new Blob([response.data], { type: 'text/csv' });

      // Create a download link
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'Stock Report.csv'; // Set the file name
      link.style.display = 'none';

      // Append the link to the body and trigger the download
      document.body.appendChild(link);
      link.click();

      // Clean up the link element
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading Excel file:', error);

      const errorMessage = error?.response?.statusText;
      console.log(errorMessage, 'errorMessage');

      const alertText =
        errorMessage === 'Not Found'
          ? 'Record not found'
          : errorMessage || 'Something went wrong';

      showErrorAlert({
        title: 'Warning',
        text: alertText,
        callback: () => {
          console.log('Error alert confirmed');
        },
      });
    }
  };

  useEffect(() => {
    fetchStockReport(0, 10);
  }, [filters]);

  return (
    <div>
      <div className="OnboardManagamentContainer ">
        <div
          style={{ width: '100%' }}
          className="OnboardManagamentbuttonContainer  col-md-3 mt-2 mb-2"
        >
          <div
            style={{
              lineHeight: '1px',
              display: 'flex',
              flexDirection: 'column',
              paddingTop: '30px',
            }}
          >
            <div>
              <p className="ServiceBreadcrumbs">Home / Report / Report </p>
            </div>
            <div>
              <h5
                style={{ fontWeight: '600' }}
                className="checkWarrantyHeading"
              >
                Admin Stock Report{' '}
              </h5>
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '25px',
            }}
          >
            <ListLogisticsFilters
              formConfig={PhysicalStockTakingInputs}
              formData={filterFormData}
              setFormData={setFilterFormData}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
              handleSearch={handleSearch}
              handleClear={clearFilter}
            />
            <div
              onClick={downloadExcel}
              className="flte-btnnn"
              style={{
                borderRadius: '38px',
                cursor: 'pointer',
                fontSize: '15px',
              }}
            >
              Export
              <span>
                <FiDownload
                  className="downloadexcel-misreportsales"
                  style={{ cursor: 'pointer' }}
                  size={22}
                />
              </span>
            </div>
            {/* <img onClick={downloadExcel} src={DownloadSVG} alt="downloadSvg" style={{ paddingTop: "33px", cursor: "pointer" }} /> */}
            {/* <div
                                      onClick={downloadExcel}
                                      className="flte-btnnn"
                                      style={{ borderRadius: "38px", cursor: "pointer",fontSize:"15px" }}
                                    >
                                      Stocks Report Download
                                      <span>
                                        <FiDownload
                                          className="downloadexcel-misreportsales"
                                          style={{ cursor: "pointer" }}
                                          size={22}
                                        />
                                      </span>
                                    </div> */}
            <div></div>
          </div>
        </div>
        <div className=" col-md-8 mt-2 mb-2 gap-2 totalvaluescontainer">
          <div className="listSideBorder" />
        </div>
      </div>
      <div className="tableWrapper">
        <div className="filterView"></div>

        <div style={{ paddingTop: '20px' }}>
          <CustomMisTable
            data={vinNoData}
            // data={paginatedData}
            headers={Job_Card_TABLE_HEADERS}
            keyMapping={BUSINESS_PARTNER_KEY_MAPPING}
            onEdit={handleEdit}
            handleViewButton={handleViewButton}
            itemsPerPage={itemsPerPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            // totalRecords={vinNoData.length}
            totalRecords={totalRecords}
            handleClaim={handleClaim}
            // isADDcomplainTable="true"

            currentPage={currentPage}
          />
          {/* )} */}
        </div>
      </div>
    </div>
  );
};

export default StockInReportAdmin;
